export default "__VITE_ASSET__Ds2C0mvm__"